export const defaultState = {
  loginState: 'LOGGED_OUT',
  loginNumber: null,
  loginEmail: null,
  emailOtpVerifier: null,
  otpVerificationDescription: null,
  loginCountryCode: null,
  appError: {
    hasError: false,
    errorTitle: 'Something went wrong',
    errorDesc: 'Check your internet connection and try again',
  },
  appFileViewer: {
    title: null,
    isOpen: false,
    contentUrl: null,
    type: 'pdf',
  },
  config: {
    showQChat: false,
    showOPD: false,
    showSubscription: false,
    showMeds: false,
    showLabs: false,
    showFeed: false,
    showFitCoins: false,
    showOffline: false,
    showSymCheck: false,
    insured: false,
    transFitCoins: false,
    insurePortal: 'https://getvisitapp.com/buy-subscription.html',
    cancellationFee: 100,
    showManageDependent: false,
    showHraHeader: true,
    showUpdatedHra: false,
    showWaterTracking: false,
    showHra: false,
    entityId: 0,
    headerText: [],
  },
  currentActiveTab: 'home',
  showNavigator: false,
  dontShowNavigator: false,
  fitnessActiveTab: 'fitness-library',
  moduleBasedLogin: false,
  hideNavigatorForBot: false,
  magicBasedLogin: false,
  googleFitnessPermission: false,
  currentSteps: 0,
  currentSleep: '0',
  tatva: false,
  showSwitchBenefitModal: false,
  preBookedProcesses: null,
  iframeFlag: null,
  ssoRequiredFields: null,
  ssoClientId: null,
  ssoEncrypted: null,
};

export default function app(state = defaultState, action) {
  switch (action.type) {
    case 'OTP_SENT':
      return Object.assign({}, state, {
        loginState: action.type,
        loginNumber: action.payload.phoneNumber,
        loginCountryCode: action.payload.countryCode,
      });
    case 'EMAIL_OTP_SENT':
      return Object.assign({}, state, {
        loginState: action.type,
        loginEmail: action.payload.email,
        emailOtpVerifier: action.payload.otpVerifier,
        otpVerificationDescription: action.payload.otpVerificationDescription,
      });
    case 'UPDATE_LOGIN_STATE':
      return Object.assign({}, state, {
        loginState: action.payload.state,
      });
    case 'SHOW_ERROR': {
      return Object.assign({}, state, {
        appError: {
          hasError: true,
          errorTitle: action.payload.errorTitle,
          errorDesc: action.payload.errorDesc,
        },
      });
    }
    case 'HIDE_ERROR': {
      return Object.assign({}, state, {
        appError: {
          hasError: false,
          errorTitle: 'Something went wrong',
          errorDesc: 'Check your internet connection and try again',
        },
      });
    }
    case 'SET_APP_CONFIG': {
      const updatedConfig = Object.assign(
        {},
        state.config,
        action.payload.config
      );
      console.log(updatedConfig, action.payload.config);
      return Object.assign({}, state, {
        config: {
          ...updatedConfig,
          showUpdatedHra: action.payload.config.showUpdatedHra || false,
        },
      });
    }
    case 'SET_CURRENT_ACTIVE_TAB': {
      return Object.assign({}, state, {
        currentActiveTab: action.payload,
      });
    }
    case 'SET_SHOW_NAVIGATOR': {
      return Object.assign({}, state, {
        showNavigator: action.payload,
      });
    }
    case 'DONT_SHOW_NAVIGATOR': {
      return Object.assign({}, state, {
        dontShowNavigator: action.payload,
      });
    }
    case 'SET_FITNESS_ACTIVE_TAB': {
      return Object.assign({}, state, {
        fitnessActiveTab: action.payload,
      });
    }
    case 'SET_MODULE_BASED_LOGIN': {
      return Object.assign({}, state, {
        moduleBasedLogin: action.payload,
      });
    }
    case 'TOGGLE_PRESCRIPTION_POPUP': {
      return Object.assign({}, state, {
        isPrescriptionPopUpOpen: action.payload,
      });
    }
    case 'HIDE_NAVIGATOR_FOR_BOT': {
      return Object.assign({}, state, {
        hideNavigatorForBot: action.payload,
      });
    }
    case 'SET_MAGIC_BASED_LOGIN': {
      return Object.assign({}, state, {
        magicBasedLogin: action.payload,
      });
    }

    case 'OPEN_FILE_VIEWER': {
      console.log('action_OPEN_FILE_VIEWER', action);
      return Object.assign({}, state, {
        appFileViewer: {
          title: action.payload.title,
          isOpen: true,
          contentUrl: action.payload.contentUrl,
          type: action.payload.type,
          showDownload:
            action.payload.showDownload === false
              ? action.payload.showDownload
              : true,
        },
      });
    }
    case 'CLOSE_FILE_VIEWER': {
      return Object.assign({}, state, {
        appFileViewer: defaultState.appFileViewer,
      });
    }
    case 'SET_INITIAL_STATE': {
      return { ...defaultState };
    }

    case 'SET_GOOGLE_FIT_PERMISSION': {
      return Object.assign({}, state, {
        googleFitnessPermission: action.payload.permissionForGoogleFit,
        currentSteps: action.payload.currentSteps,
        currentSleep: action.payload.currentSleep,
      });
    }
    case 'REMOVE_AXIOS_CACHE': {
      return {
        ...state,
        axiosResponseCache: {},
        axiosRequestQueue: [],
      };
    }
    case 'SET_TATVA': {
      return Object.assign({}, state, {
        tatva: action.payload,
      });
    }
    case 'SET_SHOW_SWITCH_BENEFIT_MODAL': {
      return Object.assign({}, state, {
        showSwitchBenefitModal: action.payload,
      });
    }
    case 'SET_PRE_BOOKED_PROCESSES': {
      return Object.assign({}, state, {
        preBookedProcesses: action.payload,
      });
    }
    case 'SET_IFRAME_FLAG': {
      return Object.assign({}, state, {
        iframeFlag: action.payload,
      });
    }
    case 'SET_SSO_MISSING_FIELDS': {
      return Object.assign({}, state, {
        ssoRequiredFields: action.payload.requiredFields,
        ssoClientId: action.payload.clientId,
        ssoEncrypted: action.payload.encrypted,
      });
    }
    default:
      return state;
  }
}
